import { useQuery } from "@tanstack/react-query";
import { SourcePartnerBillingMappingModel } from "api/client.generated";
import useApi from "../useApi";

interface UseSourcePartnerBillingMappingsReturn {
  sourcePartnerMappings: SourcePartnerBillingMappingModel[] | undefined;
  isSourcePartnerMappingsFetching: boolean;
}

const useSourcePartnerBillingMappings = (): UseSourcePartnerBillingMappingsReturn => {
  const { partnersMigrationClient } = useApi();

  const { data, isFetching } = useQuery({
    queryKey: ["getSourcePartnerBillingMappings"],
    queryFn: () => partnersMigrationClient.getSourcePartnerBillingMappings(),
  });

  return {
    sourcePartnerMappings: data,
    isSourcePartnerMappingsFetching: isFetching,
  };
};

export default useSourcePartnerBillingMappings;
